import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Users FETCH mutations on ROLES
  fetchRoles: (context, args) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchRoles';

    commit(`${mutationPrefix}Pending`);

    return api.fetchRoles(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CREATE mutations on ROLES
  createRole: (context, data) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'createRole';

    commit(`${mutationPrefix}Pending`);

    return api.createRole(data)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses UPDATE mutations on ROLES
  updateRole: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { id } = requestParams;
    const mutationPrefix = 'updateRole';

    commit(`${mutationPrefix}Pending`, id);

    return api.updateRole(requestParams)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses DELETE mutations on ROLES
  removeRole: (context, id) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'removeRole';

    commit(`${mutationPrefix}Pending`, id);

    return api.removeRole(id)
      .then((response) => {
        dispatch('delete', id);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`), { id })
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/role/actions.js